import {
  QuickAccessSection,
  FAQAccordionSection,
  SupportChannelsSection,
} from "@features/residential/components";

interface FAQPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function FAQPage({ hero, footer }: FAQPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <QuickAccessSection />
      <FAQAccordionSection />
      <SupportChannelsSection />
      {footer}
    </div>
  );
}
